import React from 'react';
import { Route } from 'react-router-dom'
import TsHeader from './TsHeader.jsx';
import TsMenuList from './TsMenuList.jsx';
import TsSprintList from './TsSprintList.jsx';

class TsIndex extends React.Component {

	render () {
		return (
			<div className="proxima tsIndex">
				<TsHeader />

				{/* On liste nos routes */}
				<Route exact path='/' component={TsMenuList}/>
				<Route path='/sprints' component={TsSprintList}/>
			</div>
		);
	}
}

export default TsIndex;


// WEBPACK FOOTER //
// ./src/js/TsIndex.jsx